import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IAutomationTabsProps {
  activeTab: number;
  onTabChange: (newTab: number) => void;
}

const AutomationTabs = ({ activeTab, onTabChange }: IAutomationTabsProps) => {
  const { t } = useTranslation();

  const tabs = [
    { label: t('Automation.messagesAutomation'), value: 0 },
    { label: t('Automation.tasksAutomation'), value: 1 },
  ];

  return (
    <Box sx={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.value;
        return (
          <Box
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            sx={{
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: '12px',
              py: '8px',
              borderRadius: '6px',
              cursor: 'pointer',
              backgroundColor: isActive ? '#EEEBFF' : 'transparent',
              fontFamily: 'Tajawal, sans-serif',
              fontSize: '14px',
              fontWeight: 700,
              lineHeight: '20px',
              color: isActive ? '#364152' : '#8E98A1',
              userSelect: 'none',
              transition: 'background-color 0.2s, color 0.2s',
            }}
          >
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default AutomationTabs;
